export default "__VITE_ASSET__3a09d18a__"